import React, {useEffect, useRef, useState} from 'react';
import Footer from "src/shared/footer/Footer";
import Header from "src/shared/header/Header";
import {jwtDecode} from "jwt-decode";
import {UserApi} from "src/service/userApi";
import './users.scss';
import binIcon from "src/asset/images/icon_bin.png";
import pencilIcon from "src/asset/images/icon_edit.png";

interface CustomJwtPayload {
    user: string;
}

export interface NewUserData {
    id: string;
    is_active: boolean;
    logged: boolean;
    passkey: string;
}

interface User {
    id: string;
    access_date?: string;
    device?: string;
    is_active?: boolean;
    logged?: boolean;
    passkey?: string;
}

const Users = () => {
    const [username, setUsername] = useState('');
    const [users, setUsers] = useState<User[]>([]);
    const [loading, setLoading] = useState(true);
    const [editingId, setEditingId] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<boolean>(false);
    const [newUser, setNewUser] = useState<NewUserData | null>(null);
    const [editingField, setEditingField] = useState<"is_active" | "logged" | "passkey" | null>(null);
    const [hoverPasswordId, setHoverPasswordId] = useState<string | null>(null);



    const tableRef = useRef<HTMLDivElement>(null);

    const handleBlur = async (e: React.FocusEvent<HTMLTableCellElement>, id: string, field: keyof User) => {
        const newValue = e.currentTarget.textContent || '';
        setUsers(prev => prev.map(u => u.id === id ? { ...u, [field]: newValue } : u));

        try {
            await UserApi.patch(id, { [field]: newValue });
            console.log('Salvato!');
        } catch (err) {
            console.error('Errore salvataggio', err);
        }
    };

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            const decodedToken = jwtDecode<CustomJwtPayload>(token);
            console.log("Token decodificato:", decodedToken);
            setUsername(decodedToken.user);
        }

        UserApi.list()
            .then((data) => {
                console.log("Dati ricevuti dall'API:", data);
                setUsers(data);
            })
            .catch((error) => {
                console.error("Errore API:", error);
            })
            .finally(() => setLoading(false));
    },

        []);


    // Funzione per eliminare un utente
    const handleDeleteUser = async (id: string) => {
        console.log("Ecco l'id:" , id);
        setLoading(true);
        try {
            await UserApi.delete(id);
            console.log("Id:", id);
            setUsers(prev => prev.filter(u => u.id !== id)); // aggiorno lo stato
            console.log("Utente eliminato:", id);
        } catch (error) {
            console.error("Errore durante la cancellazione:", error);
        } finally {
            setLoading(false);
        }

    };

    const handleAddUser = () => {
        setNewUser({
            id: '',
            is_active: false,
            logged: false,
            passkey: '',
        });
    };

    const validateNewUser = (user: NewUserData) => {
        if (!user.id || user.id.trim() === "") {
            return "ID obbligatorio";
        }

        if (!user.passkey || user.passkey.trim() === "") {
            return "Password obbligatoria";
        }

        if (typeof user.logged !== "boolean") {
            return "Valore logged non valido";
        }

        if (typeof user.is_active !== "boolean") {
            return "Valore is_active non valido";
        }

        return null;
    };




    if (loading) return <div>Caricamento utenti...</div>;
    if (!users || users.length === 0) return <div>Nessun utente trovato</div>;

    return (

        <div className="mainContainerHome">
            <div className="auth-image" />
            <div className="auth-image" />
            <Header />
            <div className='titleContainer'>
                <div>Registro utenze</div>
                <div className="spazio"></div>
            </div>
            <button className='logout-button' onClick={handleAddUser}>Aggiungi utente</button>
            <div className='spazio'></div>
            <div className="table-container">
            <table className="user">
                    <thead>
                    <tr>
                        <th>Id</th>
                        <th>Ultimo accesso</th>
                        <th>Id dispositivo</th>
                        <th>Abilitato</th>
                        <th>Connesso</th>
                        <th>Password</th>
                        <th> </th>
                    </tr>
                    </thead>
                <tbody>
                {newUser && (
                    <tr>
                        <td>
                            <input
                                className="input"
                                value={newUser.id}
                                onChange={e =>
                                    setNewUser({ ...newUser, id: e.target.value })
                                }
                            />
                        </td>

                        <td>N/A</td>
                        <td>N/A</td>

                        <td>
                            <select
                                className="select"
                                value={String(newUser.is_active)}
                                onChange={e =>
                                    setNewUser({
                                        ...newUser,
                                        is_active: e.target.value === "true"
                                    })
                                }
                            >
                                <option value="true">Attivo</option>
                                <option value="false">Non Attivo</option>
                            </select>
                        </td>

                        <td>
                            <select
                                className="select"
                                value={String(newUser.logged)}
                                onChange={e =>
                                    setNewUser({
                                        ...newUser,
                                        logged: e.target.value === "true"
                                    })
                                }
                            >
                                <option value="true">Si</option>
                                <option value="false">No</option>
                            </select>
                        </td>

                        <td>
                            <input
                                className="input"
                                value={newUser.passkey}
                                onChange={e =>
                                    setNewUser({ ...newUser, passkey: e.target.value })
                                }
                            />
                        </td>

                        <td>
                            <button
                                className="button"
                                onClick={async () => {
                                    if (!newUser) return;

                                    const error = validateNewUser(newUser);
                                    if (error) {
                                        alert(error);
                                        return;
                                    }

                                    try {
                                        const payload = {
                                            id: newUser.id.trim(),
                                            passkey: newUser.passkey.trim(),
                                            logged: newUser.logged,
                                            is_active: newUser.is_active
                                        };

                                        await UserApi.putNewUser(payload);

                                        const refreshed = await UserApi.list();
                                        setUsers(refreshed);

                                        setNewUser(null);

                                    } catch (err) {
                                        console.error("Errore nella creazione utente:", err);
                                        alert("ID o passkey già esistenti");
                                    }
                                }}
                            >
                                Salva
                            </button>
                            <button
                                className="button-rosso"
                                onClick={() => setNewUser(null)}
                            >
                                Annulla
                            </button>
                        </td>
                    </tr>
                )}

                {users.map((user: User) => {
                    const id = user.id;
                    const access_date = user.access_date
                        ? new Date(user.access_date).toLocaleString("it-IT")
                        : "N/A";
                    const device = user.device || "N/A";

                    return (
                        <tr key={user.id}>
                            <td>{id}</td>
                            <td>{access_date}</td>
                            <td>{device}</td>

                            <td>
                                {editingId === user.id ? (
                                    <select className='select'
                                            value={user.is_active ? "true" : "false"}
                                            onChange={e => {
                                                const val = e.target.value === "true";
                                                setUsers(prev => prev.map(u => u.id === user.id ? { ...u, is_active: val } : u));
                                            }}
                                    >
                                        <option value="true">Attivo</option>
                                        <option value="false">Non Attivo</option>
                                    </select>
                                ) : (
                                    user.is_active ? "Attivo" : "Non Attivo"
                                )}
                            </td>

                            <td>
                                {editingId === user.id ? (
                                    <select className='select'
                                            value={user.logged ? "true" : "false"}
                                            onChange={e => {
                                                const val = e.target.value === "true";
                                                setUsers(prev => prev.map(u => u.id === user.id ? { ...u, logged: val } : u));
                                            }}
                                    >
                                        <option value="true">Si</option>
                                        <option value="false">No</option>
                                    </select>
                                ) : (
                                    user.logged ? "Si" : "No"
                                )}
                            </td>
                            <td>
                                {editingId === user.id ? (
                                    <input
                                        type="text"
                                        className="input"
                                        value={user.passkey || ""}
                                        onChange={e => {
                                            const val = e.target.value;
                                            setUsers(prev => prev.map(u => u.id === user.id ? { ...u, passkey: val } : u));
                                        }}
                                        style={{ width: '90%' }}
                                    />
                                ) : (
                                    <span
                                        onMouseEnter={() => setHoverPasswordId(user.id)}
                                        onMouseLeave={() => setHoverPasswordId(null)}
                                        style={{ cursor: 'pointer' }}
                                    >
                              {hoverPasswordId === user.id ? user.passkey || "N/A" : "••••••"}
                            </span>
                                )}
                            </td>


                            <td>
                                {editingId === user.id ? (
                                    <button className="button-verde"
                                            onClick={async () => {
                                                try {
                                                    await UserApi.patch(user.id, {
                                                        is_active: user.is_active,
                                                        logged: user.logged,
                                                        passkey: user.passkey
                                                    });

                                                    setEditingId(null); // torna in visualizzazione normale
                                                } catch (err) {
                                                    console.error("Errore aggiornamento utente", err);
                                                    alert("Errore durante l'aggiornamento");
                                                }
                                            }}
                                    >
                                        Conferma
                                    </button>
                                ) : (
                                    <>
                                        <img
                                            src={pencilIcon}
                                            alt="Modifica utente"
                                            className="icon"
                                            onClick={() => setEditingId(user.id)}
                                        />
                                        <img
                                            src={binIcon}
                                            alt="Elimina utente"
                                            className="icon"
                                            onClick={() => handleDeleteUser(user.id)}
                                        />
                                    </>
                                )}
                            </td>
                        </tr>
                    );
                })}
                </tbody>

            </table>
            </div>

            <Footer />
        </div>
    );
};

export default Users;
